import PdpLayout from "@/components/pdp/PdpLayout";
import { EYE_REPAIR_V32 } from "@/data/eyeRepairV32";

export default function PdpConceptV32() {
  return <PdpLayout data={EYE_REPAIR_V32} />;
}
